import debounce from 'lodash/debounce';
import { node } from 'prop-types';
import React from 'react';
import { withAdsContext } from '../../hocs';
import { historyPropType, adsContextPropType } from '../../utils';
import adLogger from './logger';
import logger from '../../utils/logger';

class _AdsController extends React.Component {
  display = debounce(id => {
    adLogger(`Display del slot ${id}`);
    const { googletag } = window;
    googletag.display(id);
  }, 200);

  componentDidMount() {
    const { googletag } = window;

    // waitForLoad(window.googletag, 'pubads').then(this.setListeners);

    if (this.props.history) {
      this.unlisten = this.props.history.listen(() => {
        if (window.OBR) {
          logger.log({ msg: 'Outbrain update' });
          window.OBR.extern.researchWidget();
        }

        if (googletag && googletag.destroySlots) {
          try {
            adLogger('Destroy slots');
            googletag.destroySlots();
          } catch (err) {
            console.error(err);
          }
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { adsContext } = this.props;
    try {
      if (adsContext.state.slots.length) {
        const lastAd = adsContext.state.slots.slice(-1).pop();
        const prevLastAd = prevProps.adsContext.state.slots.slice(-1).pop();
        if (prevLastAd !== lastAd) {
          this.display(lastAd);
        }
      }
    } catch (err) {
      console.error(
        `Google TAG ERROR: Ha ocurrido un error al mostrar los anuncios`
      );
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    return this.props.children;
  }
}

_AdsController.propTypes = {
  children: node.isRequired,
  history: historyPropType.isRequired,
  adsContext: adsContextPropType.isRequired
};

const AdsController = withAdsContext(_AdsController);

export default AdsController;
